"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Story() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const paragraphs = ["Our journey began in artisanal coffee roasting — crafting small-batch beans for enthusiasts who value the nuance of origin and the precision of the pour. Over time, our focus expanded to the ritual of the cafe experience. The counter, the steam, and the quiet morning hum became our canvas, and coffee — complex, energizing, essential — became our craft.", "Today our roastery provides curated coffee selections for homes, boutique offices, and local community hubs. Every batch is roasted with intention, balanced by our master roasters, and delivered at the peak of freshness. Nothing is mass-produced, nothing is compromised by shortcuts we wouldn't serve in our own kitchen."];
  return <section data-section-id="18299" id="our-story" className="text-foreground py-20 md:py-36 dark bg-accent">
      <div className="mx-auto max-w-[1280px] px-5 md:px-10 lg:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          {}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-[120px]">
              <div ref={headingRef} className="transition-all duration-700 ease-out" style={{
              opacity: headingVisible ? 1 : 0,
              transform: headingVisible ? "translateY(0)" : "translateY(16px)",
              transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
            }}>
                <p className="font-default text-[13px] font-medium uppercase tracking-[0.14em] text-muted-foreground mb-8">
                  Our Heritage
                </p>
                <h1 className="font-default text-foreground" style={{
                fontSize: "clamp(2.25rem, 4.5vw + 0.5rem, 4.25rem)",
                fontWeight: 600,
                letterSpacing: "-0.02em",
                lineHeight: 1.05
              }}>Built to turn<em className="italic text-secondary !font-extralight !font-sans" data-ast-id="f:/src/pages/WhoWeAre/sections/Story.tsx|sig:odc2ko" data-ast-start="2366" data-ast-end="2722" contenteditable="false" style={{
                  fontWeight: '400',
                  borderBottom: '1px solid var(--primary)',
                  paddingBottom: '0.05em'
                }}><br />complexity</em>, into clarity.</h1>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 lg:pl-8">
            <div className="max-w-[560px] ml-auto">
              {}
              <div ref={imageRef} className="overflow-hidden shadow-lg" style={{
              borderRadius: "16px",
              aspectRatio: "4 / 5"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705424/img/coffee_roasting_process.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705424/img/coffee_roasting_process.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705424/img/coffee_roasting_process.png-wvc-sizes" alt="Artisan roasting coffee beans with precision" loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform" style={{
                transform: imageVisible ? "scale(1)" : "scale(1.06)",
                transitionDuration: "900ms",
                transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
              }} src="https://honest-lamprey.10web.cloud/wp-content/uploads/2026/06/Designer-1.png" />
              </div>

              {}
              <div ref={textRef} className="mt-12 max-w-[520px]">
                {paragraphs.map((para, i) => <p data-index={i} key={i} className="font-default text-foreground mb-6 last:mb-0" style={{
                fontSize: "clamp(1rem, 0.15vw + 0.95rem, 1.0625rem)",
                lineHeight: 1.6,
                letterSpacing: 0,
                opacity: textVisible ? 1 : 0,
                transform: textVisible ? "translateY(0)" : "translateY(16px)",
                transition: "opacity 720ms cubic-bezier(0.22, 1, 0.36, 1), transform 720ms cubic-bezier(0.22, 1, 0.36, 1)",
                transitionDelay: `${i * 80}ms`
              }}>Our solutions are designed around the way each client operates. Whether the challenge involves spreadsheets, reporting, data transformation, workflow improvement, or a custom business application, our focus remains the same: creating clear, secure, and practical results.</p>)}

                <p className="font-default text-foreground mt-8" style={{
                fontSize: "clamp(1rem, 0.15vw + 0.95rem, 1.0625rem)",
                lineHeight: 1.6,
                opacity: textVisible ? 1 : 0,
                transform: textVisible ? "translateY(0)" : "translateY(16px)",
                transition: "opacity 720ms cubic-bezier(0.22, 1, 0.36, 1), transform 720ms cubic-bezier(0.22, 1, 0.36, 1)",
                transitionDelay: "240ms"
              }}>We believe technology should simplify work, strengthen reporting, and give businesses information they can trust.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}